var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreventMeditation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7DB2FF;}\n\t.st1{fill:#5685E2;}\n\t.st2{fill:#A3CFFF;}\n\t.st3{fill:#618EF7;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.8,38.3V10.4c-7.7,0-13.9,6.2-13.9,13.9C7.8,32,14.1,38.3,21.8,38.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.7,24.4c0-7.7-6.2-13.9-13.9-13.9v27.8C29.4,38.3,35.7,32,35.7,24.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.7,44.2c4.6-4.6,4.6-12,0-16.6c-4.6-4.6-12-4.6-16.6,0L40.4,39.4l16.6,16.6L68.7,44.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M40.4,39.4L28.6,51.1c-4.6,4.6-4.6,12,0,16.6c4.6,4.6,12,4.6,16.6,0l11.8-11.8L40.4,39.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreventMeditation);
export default __webpack_public_path__ + "static/media/PreventMeditation.1848de74c8615332a900d46f5f1964e6.svg";
export { ForwardRef as ReactComponent };